<template>
  <el-dialog
      v-loading="loading"
      :fullscreen="true"
      :close-on-press-escape="false"
      :show-close="false"
      :close-on-click-modal="false"
      class="return-request-dialog"
      :visible.sync="visible">
    <div
        id="return-request-title"
        class="return-request-title-bar">
      <button
          v-if="!showFinalStep"
          type="button"
          class="el-dialog__headerbtn"
          style="right: unset; left: 20px"
          aria-label="Back"
          @click="back">
        <i class="el-dialog__close el-icon el-icon-arrow-left"></i>
      </button>
      <div class="order-number">
        Return for order #{{ order.order.displayable_order_id || order.order.order_id }}
      </div>
      <button
          type="button"
          class="el-dialog__headerbtn"
          aria-label="Close"
          @click="$emit('update:visible', false)">
        <i class="el-dialog__close el-icon el-icon-close"></i>
      </button>
      <StepProgressBar
          :total-steps="totalSteps"
          :current-step="currentStep" />
    </div>
    <div
        v-if="!loading"
        id="return-request-body"
        class="return-request-body">
      <div class="return-request-steps">
        <el-alert
            v-if="showInstallationWarning"
            title="Installation Service — Do Not Return"
            type="warning"
            :closable="false"
            show-icon
            style="margin-bottom: 16px">
          <span>
            Do not process returns on the Installation ASIN (IG-5X-601-PIN).
            Check your resources for guidance or reach out to leadership.
          </span>
        </el-alert>
        <StepFlowButton
            buttontext="Step 1: Select Items"
            :isactive="isactive1"
            :current-value="1"
            :disabled="isdisabled1"
            @go-back="previous" />
        <StepFlowButton
            buttontext="Step 2: Customer Details"
            :isactive="isactive2"
            :current-value="2"
            :disabled="isdisabled2"
            @go-back="previous" />
        <StepFlowButton
            buttontext="Step 3: Send return label"
            :isactive="isactive3"
            :current-value="3"
            :disabled="isdisabled3"
            @go-back="previous" />
      </div>
      <div style="border: 1px solid #DEE5EC;"></div>
      <div
          id="return-request-data"
          class="return-request-data">
        <ReturnSelectItems
            v-if="currentStep===1"
            :loading.sync="loading"
            :returnable-items="returnableItems"
            :already-selected="allItemsWithAlreadySelected"
            :return-reasons="returnReasons"
            @get-selected-items-for-return="setSelectedItemsForReturn" />
        <ReviewCustomerDetails
            v-if="currentStep===2 && !isEditDetailsStep"
            :loading.sync="loading"
            :edit-details.sync="isEditDetailsStep"
            :refund-payment-info="refundPaymentInfo"
            :refund-info="refundInfo"
            :customer="customerDetails"
            :address="address"
            :addtional-fees="additionalFees"
            :total-tax="totalTax" />
        <EditCustomerDetails
            v-if="currentStep===2 && isEditDetailsStep"
            ref="editCustomer"
            :allvalid.sync="editCustomerEnableSave"
            :customer.sync="customerDetails"
            :address.sync="address"
            :edited.sync="isEdited" />
        <ReviewReturnSummary
            v-if="currentStep===3 && !showFinalStep"
            :loading.sync="loading"
            :refund-payment-info="refundPaymentInfo"
            :refund-info="refundInfo"
            :customer="customerDetails"
            :address="address"
            :items-to-return="flattenedItemsToReturn" 
            :needs-return-label="needsReturnLabel" />
        <ReturnSummary
            v-if="currentStep===3 && showFinalStep"
            :loading.sync="loading"
            :refund-payment-info="refundPaymentInfo"
            :refund-info="refundInfo"
            :customer="customerDetails"
            :address="address"
            :return-id="returnId"
            :items-to-return="flattenedItemsToReturn"
            :needs-return-label="needsReturnLabel" />
      </div>
    </div>
    <div
        id="return-request-footer"
        class="return-request-footer">
      <el-checkbox
          v-if="showReturnSummaryConfirmationLink"
          v-model="isSummaryConfirmed"
          class="confirm-checkbox"
          style="margin-right: 24px">
        The items for return and address are correct.
      </el-checkbox>
      <el-checkbox
          v-if="showEditAddressConfirmationCheck"
          v-model="isEditConfirmed"
          class="confirm-checkbox"
          style="margin-right: 24px">
        Customer details and address are correct.
      </el-checkbox>
      <el-button
          v-if="showBack"
          class="action_button back"
          @click="back">
        Back
      </el-button>
      <el-button
          v-if="showCancel"
          class="action_button back"
          @click="cancel">
        Cancel
      </el-button>
      <el-button
          v-if="showNext"
          type="primary"
          :disabled="isNextDisabled"
          class="action_button"
          @click="next">
        Next
      </el-button>
      <el-button
          v-show="showSaveChanges"
          type="primary"
          :disabled="!isEditConfirmed || !editCustomerEnableSave"
          class="action_button"
          @click="saveChanges">
        Save Changes
      </el-button>
      <el-button
          v-if="currentStep == 3 && !showFinalStep"
          type="primary"
          :disabled="isSendReturnLabelDisabled"
          class="action_button"
          @click="finalStep">
        Send Return Label
      </el-button>
      <el-button
          v-if="currentStep == 3 && showFinalStep"
          type="primary"
          class="action_button"
          @click="exit">
        Done
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import StepProgressBar from "../StepProgressBar.vue";
import StepFlowButton from "./StepFlowButton.vue";
import ReviewCustomerDetails from "./ReviewCustomerDetails.vue";
import axios from "axios";
import EditCustomerDetails from "./EditCustomerDetails.vue";
import ReturnSelectItems from "./ReturnSelectItems.vue";
import ReviewReturnSummary from "./ReviewReturnSummary";
import ReturnSummary from "./ReturnSummary";

export default {
  name: "ReturnDialog",
  components: {
    ReviewCustomerDetails,
    StepProgressBar,
    ReturnSelectItems,
    StepFlowButton,
    EditCustomerDetails,
    ReviewReturnSummary,
    ReturnSummary,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      required: true,
    },
    exitOrderDetails: {
      type: Boolean,
      default: false,
    },
    totalTax: {
      type: Object,
      required: true,
      default() {
        return {
          amount: 0,
          currency_code: "USD",
        };
      },
    },
    showInstallationWarning: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      isEditDetailsStep: false,
      currentStep: 1,
      totalSteps: 3,
      isConfirmed: false,
      isEditConfirmed: false,
      customerDetails: {},
      address: {},
      areItemsSelected: false,
      returnableItems: [],
      returnReasons: [],
      refundPaymentInfo: {},
      refundInfo: {},
      deviceIds: [],
      selectedItems: [],
      isactive1: true,
      isactive2: false,
      isactive3: false,
      isdisabled1: false,
      isdisabled2: false,
      isdisabled3: false,
      previousValue: 1,
      editCustomerEnableSave: false,
      allItemsWithAlreadySelected: [],
      isSummaryConfirmed: false,
      displayFinalStep: false,
      returnId: "",
      additionalFees: 0,
      isEdited: false,
      showOverride: true,
      flattenedItemsToReturn: [],
      needsReturnLabel: true,
    };
  },
  computed: {
    showAddressConfirmationCheck() {
      return this.currentStep === 2 && !this.isEditDetailsStep;
    },
    showBack() {
      return this.currentStep > 1 && !this.showCancel && !this.displayFinalStep;
    },
    showNext() {
      return (
        // (this.currentStep !== 2 && !this.isEditDetailsStep) ||
        // this.currentStep !== 3

        this.currentStep < 3 && !this.isEditDetailsStep

        //   if(this.currentStep === 3){
        //     dont show
        //   }else if{
        //     (this.currentStep === 2 && this.isEditDetailsStep){
        //       dont show
        //   }
        //   } else show
      );
    },
    isNextDisabled() {
      return this.currentStep === 1 && !this.areItemsSelected;
    },
    isSaveChangesDisabled() {
      return !this.isEditConfirmed || !this.editCustomerEnableSave;
    },
    showCancel() {
      return this.currentStep === 2 && this.isEditDetailsStep;
    },
    showSaveChanges() {
      return this.currentStep === 2 && this.isEditDetailsStep;
    },
    showEditAddressConfirmationCheck() {
      return this.currentStep === 2 && this.isEditDetailsStep;
    },
    showReturnSummaryConfirmationLink() {
      return this.currentStep === 3 && !this.displayFinalStep;
    },
    isSendReturnLabelDisabled() {
      return this.currentStep === 3 && !this.isSummaryConfirmed;
    },
    showFinalStep() {
      return this.currentStep === 3 && this.displayFinalStep;
    },
  },
  watch: {
    currentStep() {
      if (this.currentStep === 1) {
        this.isactive1 = true;
        this.isactive2 = false;
        this.isactive3 = false;
      }
      if (this.currentStep === 2) {
        {
          this.isactive1 = false;
          this.isactive2 = true;
          this.isactive3 = false;
        }
      }
      if (this.currentStep === 3) {
        {
          this.isactive1 = false;
          this.isactive2 = false;
          this.isactive3 = true;
        }
      }
    },
  },

  mounted() {
    this.loading = false;
    this.customerDetails = this.order.customer;
    this.address = this.order.order.shipping_address;
    if (this.currentStep === 1) {
      this.areItemsSelected = false;
      this.loadReturnableItems();
      this.loadReturnReasons();
    }
  },
  methods: {
    previous(curValue) {
      if (this.currentStep === 2 && this.isEditDetailsStep) {
        this.isEditDetailsStep = false;
      }
      if (curValue < this.currentStep && this.currentStep > 1) {
        this.currentStep = this.currentStep - (this.currentStep - curValue);
      }
    },
    exit() {
      this.$emit("update:visible", false);
      this.$emit("exit-order-details", true);
    },
    finalStep() {
      this.loading = true;
      let arr = [];
      for (let i = 0; i < this.selectedItems.length; i++) {
        arr.push({
          sku: this.selectedItems[i].sku,
          id: this.selectedItems[i].id,
          quantity: this.selectedItems[i].quantity,
          reason_id: this.selectedItems[i].reason,
        });
      }
      return axios
        .post("v3/returns/complete_return", {
          order_id: this.order.order.displayable_order_id,
        })
        .then((response) => {
          if (response.data) {
            this.isdisabled1 = true;
            this.isdisabled2 = true;
            this.isdisabled3 = true;

            this.returnId =
              response.data.return_order.return_labels[0].tracking_id;
            this.displayFinalStep = true;
          } else {
            console.log("Invalid Data");
          }
          this.$message({
            type: "success",
            message: `Return for the order #${this.order.order.displayable_order_id} has been placed`,
          });
        })
        .catch((error) => {
          console.log(error);
          this.$message({
            type: "error",
            message: `Return for the order #${this.order.order.displayable_order_id} has not been placed. Try again.`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    back() {
      if (this.currentStep === 1) this.$emit("update:visible", false);
      else {
        if (this.isEditDetailsStep) {
          this.isEditDetailsStep = false;
          this.currentStep = 1;
        } else this.currentStep--;
      }
    },
    cancel() {
      if (this.currentStep === 2 && this.isEditDetailsStep) {
        this.isEditDetailsStep = false;
        this.isEditConfirmed = false;
      }
    },
    next() {
      if (this.currentStep === this.totalSteps) return;
      else {
        let arr = [];
        for (let i = 0; i < this.selectedItems.length; i++) {
          let item_obj = null;
          if (
            this.selectedItems[i].bundle_items != null &&
            this.selectedItems[i].bundle_items.length > 0
          ) {
            item_obj = {
              sku: this.selectedItems[i].sku,
              ecomm_order_line_item_id: this.selectedItems[i].line_item_id,
              quantity: this.selectedItems[i].quantity,
              reason_id: this.selectedItems[i].reason,
              bundle_items: this.selectedItems[i].bundle_items,
            };
          } else {
            item_obj = {
              sku: this.selectedItems[i].sku,
              ecomm_order_line_item_id: this.selectedItems[i].line_item_id,
              quantity: this.selectedItems[i].quantity,
              reason_id: this.selectedItems[i].reason,
            };
          }
          arr.push(item_obj);
        }
        this.loading = true;
        axios
          .put("v3/returns/modify_return", {
            customer: {
              name: this.customerDetails.customer_name,
              phone: this.customerDetails.customer_phone,
              email: this.customerDetails.customer_email,
              country: this.address.country,
              state: this.address.state,
              city: this.address.city,
              zip: this.address.zip,
              address_1: this.address.address_1,
              address_2: this.address.address_2,
              state_code: this.address.state_code,
              country_code: this.address.country_code,
            },
            return_items: arr,
            order_id: this.order.order.displayable_order_id,
            is_masked: !this.isEdited,
          })
          .then((response) => {
            if (response.data) {
              this.needsReturnLabel = response.data.draft.needs_return_label;
              this.refundInfo = response.data.draft.refund_info;
              let total_Tax = response.data.draft.refund_info.refund_line_items;
              for (let i = 0; i < total_Tax.length; i++) {
                this.additionalFees += total_Tax[i].total_tax;
              }
              if (this.currentStep === 2 && this.isEdited) {
                this.customerDetails.customer_name =
                  response.data.draft.customer.first_name +
                  " " +
                  response.data.draft.customer.last_name;
                this.customerDetails.customer_email =
                  response.data.draft.customer.email;
                this.customerDetails.customer_phone =
                  response.data.draft.customer.phone;
                this.address.address_1 = response.data.draft.customer.address_1;
                this.address.address_2 = response.data.draft.customer.address_2;
                this.address.city = response.data.draft.customer.city;
                this.address.state = response.data.draft.customer.state;
                this.address.country = response.data.draft.customer.country;
                this.address.zip = response.data.draft.customer.zip;
              }
              if (this.currentStep === 2) {
                this.flattenedItemsToReturn = this.selectedItems.filter(
                  (val) =>
                    val.bundle_items == null || val.bundle_items.length == 0
                );
                var bundles_list = this.selectedItems.filter(
                  (val) =>
                    val.bundle_items != null && val.bundle_items.length > 0
                );
                bundles_list.forEach((bundle_product) => {
                  bundle_product.bundle_items.forEach((bundle_item) =>
                    this.flattenedItemsToReturn.push(bundle_item)
                  );
                });
                this.flattenedItemsToReturn.forEach((item) => {
                  this.order.products.forEach((product) => {
                    if (product.sku === item.sku) {
                      item.title = product.title;
                    }
                  });
                });
              }
            } else {
              console.log("Invalid Data");
            }
            this.$message({
              type: "success",
              message: `Modify return is successful`,
            });
            if (this.currentStep === 2) {
              this.isConfirmed = false;
            }
            this.currentStep = this.currentStep + 1;
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: `Modify return has failed`,
            });
            console.log(error);
          })
          .finally(() => (this.loading = false));
      }
    },
    saveChanges() {
      this.$refs.editCustomer.saveChanges();
      this.isEditDetailsStep = false;
      this.isEditConfirmed = false;
    },
    loadRefundAmount() {
      this.loading = true;
      axios
        .post(`/v3/orders/refund_details`, {
          order_id: this.order.order.displayable_order_id,
          device_ids: this.deviceIds,
        })
        .then((response) => {
          if (response.data) {
            this.refundPaymentInfo = response.data;
          } else {
            console.log("Invalid Data");
          }
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.loading = false;
        });
    },
    loadReturnableItems() {
      this.returnableItems = this.order.order_items.filter(
        (item) => item.refundable === true && item.is_soft_bundle === false
      );
      const bundles = this.order.order_items.filter(
        (item) => item.is_soft_bundle === true
      );
      let index = this.returnableItems.length;
      let bundle_items;
      bundles.forEach((bundle) => {
        bundle_items = bundle.bundle_items.filter(
          (item) => item.refundable === true
        );
        bundle_items.forEach((item) => {
          item.id = bundle.line_item_id + parseInt(item.shippable_item_line_id);
          let current_product = this.order.products.filter(
            (product) => item.sku === product.sku
          );
          current_product = current_product.length ? current_product[0] : {};
          item.images = current_product.images;
          item.title = current_product.title;
          item.line_item_id = bundle.line_item_id;
          item.is_soft_bundle = true;
          item.parent_sku = bundle.sku;
          this.returnableItems[index++] = item;
        });
      });
      let itemsId = 0;
      let returnableItemsExpanded = [];
      this.returnableItems.forEach((item) => {
        for (let i = 0; i < item.refundable_qty; i++) {
          let tempItem = JSON.parse(JSON.stringify(item));
          tempItem.id = itemsId;
          tempItem.quantity = 1;
          returnableItemsExpanded[itemsId++] = tempItem;
        }
      });
      this.returnableItems = returnableItemsExpanded;
    },
    loadReturnReasons() {
      this.loading = true;
      axios
        .get("/v2/reasons.json?active=true")
        .then((result) => {
          const refundGroupIds = result.data.groups
            .filter((group) => group.key === "refund")
            .map((group) => group.id);
          this.returnReasons = result.data.reasons.filter((reason) =>
            refundGroupIds.includes(reason.reason_group_id)
          );
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.loading = false;
        });
    },
    setSelectedItemsForReturn(selections) {
      this.allItemsWithAlreadySelected = selections;
      this.selectedItems = selections.filter(
        (val) => val.selected && !val.is_soft_bundle
      );
      for (const item of this.selectedItems) {
        this.deviceIds.push(item.id);
      }
      let bundle_items = selections.filter(
        (val) => val.selected && val.is_soft_bundle
      );
      let line_item_id;
      bundle_items.forEach((bundle_item) => {
        line_item_id = bundle_item.line_item_id;
        let present = false;
        let item = {
          sku: bundle_item.sku,
          quantity: bundle_item.quantity,
          reason_id: bundle_item.reason,
        };
        this.selectedItems.forEach((selected_item) => {
          if (selected_item.line_item_id === line_item_id) {
            present = true;
            if (selected_item.bundle_items == null) {
              selected_item.bundle_items = [item];
            } else {
              selected_item.bundle_items.push(item);
            }
          }
        });
        if (present === false) {
          this.selectedItems.push({
            sku: bundle_item.parent_sku,
            line_item_id: bundle_item.line_item_id,
            quantity: bundle_item.quantity,
            reason: bundle_item.reason,
            bundle_items: [item],
          });
        }
      });
      let reasonNull = false;
      this.selectedItems.forEach((val) => {
        if (val.reason == null) {
          reasonNull = true;
        }
        if (val.bundle_items != null) {
          val.bundle_items.forEach((item) => {
            if (item.reason_id == null) {
              reasonNull = true;
            }
          });
        }
      });
      this.areItemsSelected = this.selectedItems.length > 0 && !reasonNull;
    },
  },
};
</script>

<style>
.return-request-title-bar {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: 9;
  height: 64px;
  background: #ffffff;

  .order-number {
    position: absolute;
    height: 24px;
    left: 72px;
    right: 72px;
    top: calc(50% - 24px / 2);

    /* body/normal-medium */

    font-family: "Equip", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    /* identical to box height, or 171% */

    display: table-cell;
    align-items: center;
    text-align: center;

    /* 🖥 light/content/base */

    color: #424242;
  }
}
.return-request-body {
  top: 64px;
  bottom: 64px;
  margin-bottom: 64px;
  position: relative;
  display: flex;
  flex-direction: row;
  overflow-y: scroll;
  min-height: calc(100% - 160px);
  background: rgb(250, 251, 252);

  .return-request-steps {
    width: 532px;
    flex: 1;
    background: #ffffff;
    padding: 40px;
  }
  .return-request-data {
    flex: 3;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    padding: 40px;
  }
}
.return-request-footer {
  position: relative;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
  height: 64px;
  background: #ffffff;
  filter: drop-shadow(0px -1px 4px rgba(0, 0, 0, 0.15));
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 16px 40px;
}

.action_button {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 16px !important;
  gap: 8px;
  width: 277px;
  height: 48px;
  flex: none;
  order: 0;
  flex-grow: 0;
  border: 1px solid #1998d5 !important;
  border-radius: 8px !important;
  font-family: "Equip", sans-serif;
  font-style: normal;
  font-weight: 500 !important;
  font-size: 18px !important;
  line-height: 28px !important;
  text-align: center !important;

  .back {
    color: #1998d5 !important;
  }

  .confirm-checkbox {
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 24px;
    color: #424242;
  }
}
</style>
